(() => {
  // src/stepper.ts
  if (!customElements.get("stepper-component")) {
    class StepperComponent extends HTMLElement {
      connectedCallback() {
        var _a, _b;
        this.input = this.querySelector('[ref="quantityInput"]');
        this.minusBtn = this.querySelector('[ref="minusButton"]');
        this.plusBtn = this.querySelector('[ref="plusButton"]');
        if (!this.input) return;
        this._onDecrease = this.decreaseQuantity.bind(this);
        this._onIncrease = this.increaseQuantity.bind(this);
        this._onBlur = this.setQuantity.bind(this);
        this._onFocus = this.selectInputValue.bind(this);
        (_a = this.minusBtn) == null ? void 0 : _a.addEventListener("click", this._onDecrease);
        (_b = this.plusBtn) == null ? void 0 : _b.addEventListener("click", this._onIncrease);
        this.input.addEventListener("blur", this._onBlur);
        this.input.addEventListener("focus", this._onFocus);
      }
      disconnectedCallback() {
        var _a, _b, _c, _d;
        (_a = this.minusBtn) == null ? void 0 : _a.removeEventListener("click", this._onDecrease);
        (_b = this.plusBtn) == null ? void 0 : _b.removeEventListener("click", this._onIncrease);
        (_c = this.input) == null ? void 0 : _c.removeEventListener("blur", this._onBlur);
        (_d = this.input) == null ? void 0 : _d.removeEventListener("focus", this._onFocus);
      }
      decreaseQuantity() {
        const step = parseInt(this.input.step) || 1;
        const prev = this.currentValue;
        const next = Math.max(this.minValue, prev - step);
        if (next === prev) return;
        this.setValue(next);
      }
      increaseQuantity() {
        const step = parseInt(this.input.step) || 1;
        const prev = this.currentValue;
        const max = this.maxValue;
        const next = max ? Math.min(max, prev + step) : prev + step;
        if (next === prev) return;
        this.setValue(next);
      }
      setQuantity() {
        const val = this.currentValue;
        const clamped = this.clamp(val);
        if (clamped !== val) this.setValue(clamped);
        else this.syncButtons();
      }
      selectInputValue() {
        this.input.select();
      }
      setValue(quantity) {
        var _a;
        const previous = this.currentValue;
        this.input.value = String(quantity);
        this.syncButtons();
        this.dispatchEvent(new CustomEvent("quantity:change", {
          bubbles: true,
          detail: {
            lineKey: ((_a = this.closest("[data-line-key]")) == null ? void 0 : _a.dataset.lineKey) || this.dataset.variantId || "",
            lineNumber: this.dataset.lineNumber ? parseInt(this.dataset.lineNumber) : null,
            variantId: this.dataset.variantId || "",
            quantity,
            previousQuantity: previous
          }
        }));
      }
      syncButtons() {
        const val = this.currentValue;
        const max = this.maxValue;
        if (this.minusBtn) this.minusBtn.disabled = val <= this.minValue;
        if (this.plusBtn) this.plusBtn.disabled = max !== null && val >= max;
      }
      clamp(val) {
        const max = this.maxValue;
        let clamped = Math.max(this.minValue, val);
        if (max !== null) clamped = Math.min(max, clamped);
        return clamped;
      }
      get currentValue() {
        return parseInt(this.input.value) || 0;
      }
      get minValue() {
        return parseInt(this.input.min) || 0;
      }
      get maxValue() {
        const m = parseInt(this.input.max);
        return isNaN(m) ? null : m;
      }
    }
    customElements.define("stepper-component", StepperComponent);
  }
})();
